export default __webpack_public_path__ + "static/media/arrow-left-circle-fill.32429b5f.svg";